import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EScoreGroupTypes } from 'components/searchAndFilter/constants';
import { ECanvasPreferencesKeys } from 'enums/ECanvasPreferencesKeys';
import { canvasPreferenceThunk } from 'redux/thunks/common';

export enum ESelectedHitButton {
  None = 0,
  AnyHits = 1,
  AllHits = 2,
}
type HeaderState = {
  scoreGroup: number;
  autoSelectNextWell: boolean;
  hideAutoScores: boolean;
  hitButton: ESelectedHitButton;
  hitScoreGroupType: string;
  hitScoreGroup: number;
  uvHitsOnly: boolean;
};

const initialState = {
  hitButton: ESelectedHitButton.None,
  hitScoreGroupType: EScoreGroupTypes.All,
  hitScoreGroup: 0,
  uvHitsOnly: false,
} as HeaderState;

export const headerSlice = createSlice({
  name: 'experiment',
  initialState,
  reducers: {
    setHeaderScoresGroupType: (state, action: PayloadAction<number>): void => {
      state.scoreGroup = action.payload;
    },
    setAutoSelectNextWell: (state, action: PayloadAction<boolean>): void => {
      state.autoSelectNextWell = action.payload;
    },
    setHideAutoScores: (state, action: PayloadAction<boolean>): void => {
      state.hideAutoScores = action.payload;
    },
    setHitButton: (state, action: PayloadAction<ESelectedHitButton>) => {
      state.hitButton = action.payload;
    },
    setHitScoreGroupType: (state, action: PayloadAction<string>) => {
      state.hitScoreGroupType = action.payload;
    },
    setHitScoreGroup: (state, action: PayloadAction<number>) => {
      state.hitScoreGroup = action.payload;
    },
    setUvHitsOnly: (state, action: PayloadAction<boolean>) => {
      state.uvHitsOnly = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(canvasPreferenceThunk.fulfilled, (state, action) => {
      state.autoSelectNextWell = action.payload[
        ECanvasPreferencesKeys.AutoMoveAfterScoring
      ] as boolean;
    });
  },
});

export const {
  setHeaderScoresGroupType,
  setAutoSelectNextWell,
  setHideAutoScores,
  setHitButton,
  setHitScoreGroupType,
  setHitScoreGroup,
  setUvHitsOnly,
} = headerSlice.actions;

export default headerSlice.reducer;
